const DOCS_BASE_URL = process.env.REACT_APP_DOCS_BASE_URL;

export const OPENAPI_LINTING_SKILL_URL = `${DOCS_BASE_URL}content/how-to-guides/publishapi/api-standards-linting-skill/`;
